import { Box, CircularProgress } from "@mui/material";

interface SettingsPageShellProps {
  readonly isLoading: boolean;
  readonly loadingMessage: string;
  readonly children: React.ReactNode;
}

export default function SettingsPageShell({
  isLoading,
  loadingMessage,
  children,
}: SettingsPageShellProps) {
  if (isLoading) {
    return (
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "100%",
          gap: "12px",
          color: "var(--text-secondary)",
        }}
      >
        <CircularProgress size={20} />
        <span>{loadingMessage}</span>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        height: "100%",
        overflow: "hidden",
        backgroundColor: "var(--bg-deep)",
        padding: "12px",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          height: "100%",
          overflow: "hidden",
          backgroundColor: "var(--bg-surface)",
          border: "1px solid var(--border-subtle)",
          borderRadius: "8px",
        }}
      >
        {children}
      </Box>
    </Box>
  );
}
